document.addEventListener('DOMContentLoaded', () => {
  function initZoom() {
    document.querySelectorAll('drag-zoom-wrapper').forEach(wrapper => {
      wrapper.addEventListener('mousemove', (e) => {
        const rect = wrapper.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width - 0.5) * 100;
        const y = ((e.clientY - rect.top) / rect.height - 0.5) * 100;
        wrapper.style.setProperty('--drag-zoom-translate-x', `${x}px`);
        wrapper.style.setProperty('--drag-zoom-translate-y', `${y}px`);
        wrapper.style.setProperty('--drag-zoom-scale', '2');
      });
      wrapper.addEventListener('mouseleave', () => {
        wrapper.style.setProperty('--drag-zoom-translate-x', '0px');
        wrapper.style.setProperty('--drag-zoom-translate-y', '0px');
        wrapper.style.setProperty('--drag-zoom-scale', '1');
      });
    });
  }
  initZoom();
  document.addEventListener('dialog:open', initZoom);
});
